export default {"src":"/_next/static/media/product-icon-dark.b99a0d48.svg","height":36,"width":37,"blurWidth":0,"blurHeight":0};